export const SPACER_AND_DIVIDER_TYPE = {
  TEXT: "text",
  ONLY_DIVIDER: "only_divider",
  ONLY_ICON: "only_icon",
  TEXT_WITH_ICON: "text-with-icon",
};

export const SPACER_AND_DIVIDER_PROP = {
  DIVIDER_COLOR: "color",
  DIVIDER_ICON: "dividerIcon",
  DIVIDER_TYPE: "dividerType",
  WEIGHT: "weight",
  WIDTH: "width",
  EMOJI: "emoji",
  EMOJI_ENABLED: "emojiEnabled",
  FONT_SIZE: "fontSize",
  ICON_COLOR: "iconColor",
  ICON_SIZE: "iconSize",
  IS_EDITING_ICON_OR_EMOJI: "isEditingIconOrEmoji",
  LABEL_POSITION: "labelPosition",
  TEXT: "text",
  TEXT_ALIGNMENT: "textAlignment",
  TEXT_COLOR: "textColor",
};
